import { useEffect, useState } from "react";
import axios from "axios";
import { motion } from "framer-motion";
import { ProductCard } from "../components/ProductCard";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Shop() {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios
      .get(`${API}/products`)
      .then((r) => setProducts(r.data))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  return (
    <main data-testid="shop-page" className="pt-40 pb-32">
      <div className="max-w-7xl mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
          className="mb-20 max-w-2xl"
        >
          <p className="overline-tag mb-6">Pre-order &amp; Farm Gate Pickup</p>
          <h1 className="font-display text-5xl sm:text-6xl tracking-tighter font-light text-zinc-100 leading-[1.05]">
            The full <span className="italic text-saffron">harvest</span>
          </h1>
          <p className="mt-8 text-base leading-relaxed text-zinc-400">
            Add listings to your basket and place a pre-order — no payment now. We confirm
            availability and your harvest window by email, and you pay at the farm gate in
            Mount Albert.
          </p>
        </motion.div>

        {loading ? (
          <div data-testid="shop-loading" className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {[...Array(6)].map((_, i) => (
              <div key={i} className="border border-line bg-surface animate-pulse">
                <div className="h-[280px] bg-line/40" />
                <div className="p-8 space-y-4">
                  <div className="h-3 w-24 bg-line/40 rounded" />
                  <div className="h-6 w-48 bg-line/40 rounded" />
                  <div className="h-3 w-full bg-line/40 rounded" />
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {products.map((p, i) => (
              <ProductCard key={p.id} product={p} index={i} large={i === 0} />
            ))}
          </div>
        )}
      </div>
    </main>
  );
}
